import { Row, Col } from 'antd';
import { useState, useEffect } from 'react';
import { DatabaseOutlined, ExperimentOutlined, ShoppingOutlined, PercentageOutlined } from '@ant-design/icons';
import PaginatedTableProduccion from '../../../components/reportes/produccion/PaginatedTableProduccion';
import { withAuthenticationRequired, useAuth0 } from "@auth0/auth0-react";
import HomeBarChart from '../../../components/reportes/home/HomeBarChart';
import GenericLineChart from '../../../components/reportes/GenericLineChart';
import { PageTitle, StatCard, StatCardsContainer } from '../../../components/common';
import { theme } from '../../../theme';

const Produccion = () => {  
  
    const {user, getAccessTokenSilently} = useAuth0();

    // Para guardar la tabla de Lotes.
    // const [tableData, setTable] = useState([]);
    // const [nro_cliente, setSelectedClient] = useState("all"); 

    const [avgRindeSemilla, getAvgRindeSemilla] = useState(0);
    const [avgRindeFibra, getAvgRindeFibra] = useState(0);
    const [KgSemilla, getKgSemilla] = useState(0);
    const [KgFibra, getKgFibra] = useState(0);
    const [CantidadFardos, getCantidadFardos] = useState(0);
    const [fullData, getFullData] = useState([]);
    const [isLoading, getisLoading] = useState(true);

    const [barchartData, setBarchartData] = useState<any>([]);

    const id_empresa = user?.id_empresa
    const id_cliente = user?.id_cliente 
    const tipo_usuario = user?.tipo_usuario
  
    const variables_api = `${tipo_usuario}/${id_empresa}/${id_cliente}`

    const transformDataForChart = (data: any[], dateField: string, valueFields: string[]) => {
      return valueFields.map(field => ({
        label: field.charAt(0).toUpperCase() + field.slice(1), // Capitalize field name for label
        data: data.map(row => ({
          date: new Date(row[dateField]),
          value: row[field]
        }))
      }));
    };

    const dataFibraSemilla = transformDataForChart(fullData, 'fecha', ['kg_fibra', 'kg_semilla']);
    const dataRindeFibraSemilla = transformDataForChart(fullData, 'fecha', ['rinde_fibra', 'rinde_semilla']);

    // Para decidir que API llamar
    const apiEndpoint = tipo_usuario !== "D" 
      ? `${process.env.REACT_APP_REPORTES_URL}/produccion/barchart_establecimientos/${variables_api}`
      : `${process.env.REACT_APP_REPORTES_URL}/home/barchart_kg_fibra/${variables_api}`;

    useEffect(() => {
      const fetchData = async () => {
        try {
          const token = await getAccessTokenSilently();
          const response = await fetch(apiEndpoint, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
          const data = await response.json();
          setBarchartData(Array.isArray(data) ? data : []);
        } catch (error) {
          console.error('Error fetching data:', error);
          setBarchartData([]);
        }
      };
      if (variables_api && tipo_usuario) {
        fetchData();
      }
    }, [variables_api, tipo_usuario, apiEndpoint, getAccessTokenSilently]); 
    
    return (
      <div style={{ padding: '0' }}>
        <PageTitle>Producción</PageTitle>
        <StatCardsContainer gap={16} minColumnWidth="180px">
          <StatCard
            title="Cantidad Fardos"
            value={CantidadFardos}
            icon={<DatabaseOutlined />}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
          <StatCard
            title="Rinde Fibra"
            value={`${avgRindeFibra}%`}
            icon={<PercentageOutlined />}
            color={theme.colors.primary}
            loading={isLoading}
          />
          <StatCard
            title="Rinde Semilla"
            value={`${avgRindeSemilla}%`}
            icon={<PercentageOutlined />}
            color={theme.colors.primary}
            loading={isLoading}
          />
          <StatCard
            title="Kg. Fibra"
            value={KgFibra}
            icon={<ExperimentOutlined />}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
          <StatCard
            title="Kg. Semilla"
            value={KgSemilla}
            icon={<ShoppingOutlined />}
            color={theme.colors.primary}
            formatNumber
            loading={isLoading}
          />
        </StatCardsContainer>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
          <Col xs={24} lg={24}>
            <div style={{ 
              width: '100%', 
              height: '300px',
              borderRadius: theme.styles.borderRadius,
              boxShadow: theme.styles.boxShadowLight,
              backgroundColor: '#fff'
            }}>
              <HomeBarChart  
                title={tipo_usuario === "D" ? 'Kg. Fibra por Cliente' : 'Kg. Fibra por Establecimiento'}
                barChartData={barchartData}
                xlabel={tipo_usuario === "D" ? 'Cliente' : 'Establecimiento'}/>
            </div>
          </Col>  
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
          <Col xs={24} lg={24}>
            <div style={{ 
              width: '100%', 
              height: '300px',
              borderRadius: theme.styles.borderRadius,
              boxShadow: theme.styles.boxShadowLight,
              backgroundColor: '#fff'
            }}>
              <GenericLineChart
                title="Suma de Kg. Fibra y Semilla por día"
                datasets={dataFibraSemilla}
                aggregationType="daily"
                aggregationMethod="sum"
              />
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
          <Col xs={24} lg={24}>
            <div style={{ 
              width: '100%', 
              height: '300px',
              borderRadius: theme.styles.borderRadius,
              boxShadow: theme.styles.boxShadowLight,
              backgroundColor: '#fff'
            }}>
              <GenericLineChart
                title="Promedio Rinde Fibra y Semilla por día"
                datasets={dataRindeFibraSemilla}
                aggregationType="daily"
                aggregationMethod="avg"
              />
            </div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
          <Col xs={24} lg={24}>   
            <PaginatedTableProduccion
                csvName={"reporte_produccion.xlsx"}
                variables_api={variables_api}
                getKgFibra={getKgFibra}
                getKgSemilla={getKgSemilla}
                getAvgRindeFibra={getAvgRindeFibra}
                getAvgRindeSemilla={getAvgRindeSemilla}
                getCantidadFardos={getCantidadFardos}
                getFullData={getFullData}
                getisLoading={getisLoading}>
            </PaginatedTableProduccion>  
          </Col>
        </Row>
      </div>
    );
};

export default withAuthenticationRequired(Produccion); //Produccion;